import { Component, Input } from '@angular/core';
import { ScoutingTeamViewModel, TeamViewModel } from '../../../shared/models/TeamModels';

@Component({
  selector: 'app-team-header',
  imports: [],
  templateUrl: './team-header.component.html',
  styleUrl: './team-header.component.css',
})
export class TeamHeaderComponent {

  @Input() Team: ScoutingTeamViewModel;
}
